const PreviewImageCredits = (props) => {
  const caption = props.content.preview_caption;
  return <div className="preview-image-caption caption">{caption}</div>;
};

export default PreviewImageCredits;
